import React from "react";

const DefaultCard = ({ title, description, bgColor, image, onClick }) => {
  return (
    <div>
      <div
        onClick={onClick}
        className={`p-4 rounded-xl shadow-md ${bgColor}`}
      >
        <div className=" flex my-4 justify-between items-center">
          <h3 className="text-sm transform transition-transform duration-300 group-hover:translate-x-1 cursor-pointer font-bold mb-2">
            {title}
          </h3>
          <img
            className=" w-10"
            src={image}
            alt={title}
          />
        </div>

        <p className="text-sm font-[400]">{description}</p>
      </div>
    </div>
  );
};

export default DefaultCard;
